import React, { Component } from 'react';

import './index.scss';

class AnimatedTextArea extends Component {
    constructor(props) {
        super(props);
        this.state = {
            animated: false,
            height: false,
            origin_height:false,
            lines:1,
        }

        this.ref = React.createRef();

        this.handleOnKeyUp = this.handleOnKeyUp.bind(this);
    }

    componentDidMount(){
        this.setState({origin_height: this.ref.current.offsetHeight});
    }

    animatePlaceholder(e) {
        let val = e.target.value;
        if (val === '')
            this.setState({height: false});
        this.setState({animated:(val !== '')});
        this.props.onChange(e);
    }

    handleOnKeyUp(e){
        if (e.keyCode === 13){
            if (this.state.lines < 5) {
                const font_size = parseFloat(window.getComputedStyle(this.ref.current, null).getPropertyValue('font-size'));
                this.setState({height: font_size * (this.state.lines + 4), lines: this.state.lines + 1});
            }
            else{
                e.preventDefault();
            }
        }
    }

    render() {
        const {
            type,
            name,
            placeholder = '',
            value = '',
            showError,
            className,
            errorMessage = 'empty or undefined errorMessage prop',
            tabIndex } = this.props;

        return (
            <div className = {className + ' animated_textarea_wrapper animated' + (showError ? ' error' : '') + (this.state.animated ? ' animate' : '')}>
                <label testID= {`animated-textarea-label-${name}`}>{ placeholder }</label>
                <textarea type      = { type }
                          name      = { name }
                          value     = { value }
                          ref       = {this.ref}
                          onChange  = { (e) => this.animatePlaceholder(e) }
                          tabIndex  = { tabIndex }
                          onKeyUp   = { this.handleOnKeyUp}
                          style     = {{height: (this.state.height ? this.state.height : this.state.origin_height)}}
                          testID= {`animated-textarea-${name}`}
                />
                <div testID= {`animated-textarea-placeholder-${name}`} className="placeholder">{ placeholder }</div>
                {showError ? <div testID= {`animated-textarea-error-${name}`} className = "error_text">{ errorMessage }</div> : ''}
            </div>
        )
    }
}
export default AnimatedTextArea;
